import { operatorColors } from '~/utils/operatorColors';
import { CustomInputDrop } from '~/utils/CustomInputDrop';
import { CustomHandle } from '~/utils/CustomHandle';

// Node de soma
export const OperatorSumNode = ({ data, notNode = false, onDataChange }) => {
    // Função para lidar com a mudança dos drops de entrada
    const handleLeftChange = (newDrop) => onDataChange({ leftDrop: newDrop, rightDrop: data.rightDrop });
    const handleRightChange = (newDrop) => onDataChange({ leftDrop: data.leftDrop, rightDrop: newDrop });
    const layout = data?.layout || 'vertical';
    const isHorizontal = layout === 'horizontal';
    const horizontalDropStyle = isHorizontal ? { minWidth: 80, flex: '0 0 auto', maxWidth: 'none' } : undefined;
    return (
        <div className="node-operator-sum" style={{ 
            display: 'flex', 
            flexDirection: layout === 'vertical' ? 'column' : 'row',
            flexWrap: isHorizontal ? 'nowrap' : 'wrap',
            alignItems: 'center', 
            justifyContent: 'center',
            gap: '8px',
            width: '100%'
        }}>
            <CustomInputDrop
                dropData={data.leftDrop || { id: 'left', type: null, data: {} }}
                dropId="left"
                onDropChange={handleLeftChange}
                style={horizontalDropStyle}
            />
            <div style={{
                background: operatorColors.Soma || '#4caf50',
                color: 'white',
                borderRadius: '8px',
                padding: '8px 12px',
                fontWeight: 'bold',
                fontSize: '18px',
                minWidth: '40px',
                textAlign: 'center',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                +
            </div>
            <CustomInputDrop
                dropData={data.rightDrop || { id: 'right', type: null, data: {} }}
                dropId="right"
                onDropChange={handleRightChange}
                style={horizontalDropStyle}
            />
            {!notNode && <CustomHandle type="target" position="top" connectionCount={1} />}
            {!notNode && <CustomHandle type="source" position="bottom" connectionCount={1} />}
        </div>
    );
};